module.exports = {"ApprovalHistoryId":"_","Action":{"label":"Action","width":200},"User":"User","Description":{"label":"Description","width":530},"CreatedDate":"Created"}


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/Approvals/Approval-history/model.json
// module id = k9gP
// module chunks = 12